import SkipBackIcon from 'widget/components/SkipBackButton/primitives/SkipBackIcon';
import StyledSkipBackButton from 'widget/components/SkipBackButton/primitives/StyledSkipBackButton';

type Props = {
  onClick: () => void;
  sizeToHide: string;
};

export default function SkipBackButton({ onClick, sizeToHide }: Props) {
  return (
    <StyledSkipBackButton
      aria-label="Skip back 30 seconds"
      data-test="skip-back-button"
      onClick={onClick}
      sizeToHide={sizeToHide}
      type="button"
    >
      <SkipBackIcon />
    </StyledSkipBackButton>
  );
}
